import { TokenSelector } from "@biz-store/auth/feature.selectors";
import { createSelector } from "@ngrx/store";
import { SubdomainList } from "../link-an-account-dialog/selectors";

export const SelectedSubdomain = createSelector(TokenSelector, SubdomainList, (state, list) => list[state.linkingIndex]);
export const CompanyName = createSelector(SelectedSubdomain, (state) => state.companyName);
//TODO: link to original identity ID
export const Owner = createSelector(SelectedSubdomain, (state) => state.userName);